import { GridLayoutBreakpoint } from '../enums/GridLayoutBreakpoint';

export const gridLayoutCols = {
  [GridLayoutBreakpoint.Large]: 12,
  [GridLayoutBreakpoint.Medium]: 12,
  [GridLayoutBreakpoint.Small]: 12,
  [GridLayoutBreakpoint.ExtraSmall]: 12,
  [GridLayoutBreakpoint.ExtraExtraSmall]: 12,
};
